// Studyo Today Backend
// Package studyo.schools.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/account.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_studyo_today_schools_v1_resources_account_kind } from "./account_kind_pb.js";
import { file_studyo_today_schools_v1_resources_external_source } from "./external_source_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/account.proto.
 */
export const file_studyo_today_schools_v1_resources_account = /*@__PURE__*/
  fileDesc("Ci9zdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvYWNjb3VudC5wcm90bxIhc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzIvkCCgdBY2NvdW50EgoKAmlkGAEgASgJEjwKBGtpbmQYAiABKA4yLi5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuQWNjb3VudEtpbmQSEQoJc2Nob29sX2lkGAMgASgJEkoKD2V4dGVybmFsX3NvdXJjZRgEIAEoCzIxLnN0dWR5by50b2RheS5zY2hvb2xzLnYxLnJlc291cmNlcy5FeHRlcm5hbFNvdXJjZRIwCgxjcmVhdGVkX3RpbWUYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjAKDHVwZGF0ZWRfdGltZRgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEgoKc3luY190b2tlbhgHIAEoAxIRCglmdWxsX25hbWUYCCABKAkSFQoNZW1haWxfYWRkcmVzcxgJIAEoCRISCgppc19kZWxldGVkGAogASgIEg8KB3VzZXJfaWQYCyABKAlCKaoCJlN0dWR5by5Ub2RheS5TY2hvb2xzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM", [file_google_protobuf_timestamp, file_studyo_today_schools_v1_resources_account_kind, file_studyo_today_schools_v1_resources_external_source]);

/**
 * Describes the message studyo.today.schools.v1.resources.Account.
 * Use `create(AccountSchema)` to create a new message.
 */
export const AccountSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_account, 0);

